import { render, staticRenderFns } from "./PendenciesDisapproved.vue?vue&type=template&id=067dbd69&scoped=true"
import script from "./PendenciesDisapproved.vue?vue&type=script&lang=js"
export * from "./PendenciesDisapproved.vue?vue&type=script&lang=js"
import style0 from "./PendenciesDisapproved.vue?vue&type=style&index=0&id=067dbd69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067dbd69",
  null
  
)

export default component.exports